import swiperDirective from './swiper.directive'

const module = angular.module('mpa.components.swiper', [])

module.directive('swiper', swiperDirective)

export default module.name
